import { useState } from 'react'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

import type { UsersSummaryShellProps } from '@/modules/employer/pages/components/UsersSummaryShell/UsersSummaryShell.types'

import { UsersSummary } from '@/components/@Shared/UserManagmentCharts/UserSummary/UsersSummary'

import { useEmployerStatsServiceEmployerStatsControllerGetUserStats } from '@/__generated__/queries'

export function UsersSummaryShell({
  onUpdateChartsData,
}: UsersSummaryShellProps) {
  const now = dayjs()

  const [startDate, setStartDate] = useState<Dayjs>(now.startOf('month'))
  const [endDate, setEndDate] = useState<Dayjs>(now.endOf('month'))

  const handleMonthChange = (value: Dayjs) => {
    setEndDate(value.endOf('month').endOf('day'))
    setStartDate(value.startOf('month').endOf('day'))
  }

  const { data, isFetching, isLoading } =
    useEmployerStatsServiceEmployerStatsControllerGetUserStats({
      endDate: endDate.toISOString(),
      startDate: startDate.toISOString(),
    })

  return (
    <UsersSummary
      data={data}
      endDate={endDate}
      isLoading={isLoading || isFetching}
      onMonthChange={handleMonthChange}
      onUpdateChartsData={onUpdateChartsData}
      startDate={startDate}
    />
  )
}
